import React from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { isViDomain } from '../../constants/viIntegration';

const RequestDemoNearFooter = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const isBelow991 = useMediaQuery("(max-width:991px)");
  const {setShowSignUpModal,showSignUpModal, setMenuOpen} = useAuth()

  // Don't render in Vi app WebView or Vi domain
  if (window.ReactNativeWebView || isViDomain()) return null;
  const handleRedirect = (link) => {
    window.open(link, '_blank'); // Opens the link in a new tab
  };
  
  const handleGetStarted = () =>{
    if (isLoggedIn){
      navigate('/workspace') 
    }
    else {
      // setShowSignUpModal(true) 
      navigate('./signup')
      setMenuOpen(true)

    }  
   }
 
  return (
    <Box sx={{height:isBelow991 ? "527px" :"538px", paddingTop:isBelow991 ? "169px" : "180px"}}>
    <Box sx={{ width: '100%' ,backgroundColor: '#1c2039', height: '358px', margin: 'auto', background:'linear-gradient(94deg, #1F233E -51.34%, #171A2D 150.36%)' }}>
      <Box
        sx={{
          maxWidth: '1072px',
          height: '358px', // Match the height of the parent Box to ensure centering
          margin: 'auto',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center', // Centers content vertically
          alignItems: 'center', // Centers content horizontally
          width: isBelow991?'90%':'100%',
        }}
      >
        <Typography sx={{ fontSize: isBelow991?'28px':'48px',fontFamily:"Inter" ,fontStyle:"normal", fontWeight:500, lineHeight:"120%", letterSpacing:"-0.32px", textAlign:"center", color: 'white', marginBottom: '28px' }}>
          {/* Ready to speed up your workflow using AI? */}
          Ready to Transform Your Business with AI?
        </Typography>
        <Typography sx={{ fontSize: isBelow991?'14px':'18px', fontFamily:"Inter" ,fontStyle:"normal", fontWeight:500, lineHeight:"24px", letterSpacing:"0.1px", textAlign:"center" , color: 'rgba(255,255,255,0.8)', marginBottom: '48px', maxWidth:"704px" }}>
          {/* Start exploring ModalX! Request a free demo today */}
          Experience the power of simple, personalized, and actionable AI. Try ModalX for free today!
        </Typography>
        <Box
          sx={{
            width: isBelow991?'350px':'370px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            // onClick={() => handleRedirect('mailto:noreply@ModalX.ai')}
            onClick={() => window.open('https://calendly.com/makarand-modalx', '_blank')}
            variant="outlined"
            sx={{
              width: '161px',
              height: '40px',
              borderColor: '#F6BE6A',
              color: '#F6BE6A',
              textTransform: 'none',
              fontSize: isBelow991?'14px':'16px',
              '&:hover': {
                borderColor: '#F6BE6A',
                backgroundColor: 'transparent', // No border color changes on hover
              },
              fontFamily: 'Inter, sans-serif',
            }}
          >
            Request demo
          </Button>
          <Button
          onClick={handleGetStarted}
            variant="contained"
            sx={{
              width: '173px',
              height: '40px',
              backgroundColor: '#F6BE6A',
              color: '#17182C',
              fontWeight: '600',
              textTransform: 'none',
              fontSize: isBelow991?'14px':'16px',
              '&:hover': {
                backgroundColor: '#ffd9aa', // Changes background color on hover
              },
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {isLoggedIn?"Go to workspace":"Get started free"}
          </Button>
        </Box>
      </Box>
    </Box>
    </Box>
  );
};

export default RequestDemoNearFooter;
